/*
 * 企業側 マイページ コンサルタント選定
 */
import { apiGetOne } from '@/actions/ApiBaseActions';
export const API_GET_ONE_CLIENT_MY_PAGE_CONSULTATIONS_DRAFT = 'API_GET_ONE_CLIENT_MY_PAGE_CONSULTATIONS_DRAFT';
export const API_GET_ONE_CLIENT_MY_PAGE_CONSULTATIONS_DRAFT_SUCCESS = 'API_GET_ONE_CLIENT_MY_PAGE_CONSULTATIONS_DRAFT_SUCCESS';
/**
 * コンサルタント選定 下書き 取得
 * @param {*} _data
 * @param {*} meta
 * @returns
 */
export const apiGetOneClientConsultationDraft = (_data, meta) => apiGetOne(API_GET_ONE_CLIENT_MY_PAGE_CONSULTATIONS_DRAFT, '/client/consultation_draft', Object.assign(Object.assign({}, meta), { isSnakeCase: true }));
